import LoadScene from '@scenes/LoadScene';
import StartScene from '@scenes/StartScene';
import IntroScene from '@scenes/IntroScene';
import GameScene from '@scenes/GameScene';
import EndScene from '@scenes/EndScene';

export default [
  { key: 'LoadScene', scene: LoadScene, autoStart: true },
  { key: 'StartScene', scene: StartScene },
  { key: 'IntroScene', scene: IntroScene },
  { key: 'GameScene', scene: GameScene },
  { key: 'EndScene', scene: EndScene },
];
